import Vue from 'vue'
import Vuex from 'vuex'
import { fbind } from 'q';
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

export const store = new Vuex.Store({
    state:{
        currentUser: null,
        userProfile: {},
        editorComponentKey:0

    },
    actions:{
        fetchUserProfile({commit,state}){
            fb.usersCollection.doc(state.currentUser.uid)
            .get().then(res =>{
                commit('setUserProfile',res.data())

            }).catch(err => {
                console.log(err);
            });
        },
        clearData({commit}){
            commit('setCurrentUser',null)
            commit('setUserProfile',{})
        },
        forceEditorRefresh({commit}){
            commit('incrementEditorComponentKey', 1)
        }
    },
    mutations:{
        setCurrentUser(state,val){
            state.currentUser = val;
        },
        setUserProfile(state,val){
            state.userProfile = val;
        },
        incrementEditorComponentKey(state,val){
            state.editorComponentKey += val;
        }
    }

})